export default __webpack_public_path__ + "static/hero-image-33f73c8de0bc388384ecf0fe0b445862.jpg";